import React, { Component } from 'react';
import classnames from 'classnames';
import CSSCore from 'fbjs/lib/CSSCore';
import PropTypes from 'prop-types';
import domHelperScrollTop from 'dom-helpers/query/scrollTop';

import Introduction from './Introduction';
import WorkSuite from './WorkSuite';
import WorkDocs from './WorkDocs';
import AwsDemo from './AwsDemo';
import HeartWriter from './HeartWriter';
import Generator from './Generator';
import Favorites from './Favorites';
import Design from './Design';
import Modal from './Modal';

import '../styles/App.css';

const MODAL_ANIM = {
  SHOWING: 'showing',
  VISIBLE: 'visible',
  HIDING: 'hiding',
  HIDDEN: 'hidden',
};

class App extends Component {

  static childContextTypes = {
    openModal: PropTypes.func
  };

  state = {
    modalInfo: null,
    animate: MODAL_ANIM.HIDDEN
  };

  getChildContext() {
    return {
      openModal: (element) => {
        CSSCore.addClass(document.body, 'modal');

        this.setState({
          modalInfo: {
            element
          },
          animate: MODAL_ANIM.SHOWING,
          scrollTopWhenModalShown: domHelperScrollTop(window)
        });
      }
    };
  }

  render() {
    return (
      <div
        className={classnames('App', {
          [this.state.animate]: true
        })}
        onAnimationEnd={this._onAnimationEnd}>
        <div className="App-outer">
          <div
            className="App-inner"
            style={this.state.animate === MODAL_ANIM.HIDDEN ? {} : {
              top: `-${this.state.scrollTopWhenModalShown}px`
            }}>
            <Introduction/>
            <WorkSuite/>
            <WorkDocs/>
            <AwsDemo/>
            <HeartWriter/>
            <Generator/>
            <Favorites/>
            <Design/>
          </div>
        </div>
        <div className="App-modalOverlay"/>
        <Modal
          modalInfo={this.state.modalInfo}
          onClickClose={this._onClickCloseModal}
        />
      </div>
    );
  }

  componentDidMount() {
    window.mixpanel.track('Loaded app');
  }

  _onAnimationEnd = evt => {
    if (this.state.animate === MODAL_ANIM.SHOWING) {
      this.setState({
        animate: MODAL_ANIM.VISIBLE
      });
    } else if (this.state.animate === MODAL_ANIM.HIDING) {
      this.setState({
        modalInfo: null,
        animate: MODAL_ANIM.HIDDEN
      }, () => {
        domHelperScrollTop(window, this.state.scrollTopWhenModalShown || 0);
      });
    }
  };

  _onClickCloseModal = () => {
    CSSCore.removeClass(document.body, 'modal');

    this.setState({
      animate: MODAL_ANIM.HIDING
    });
  };

}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js